<template>
  <div id="layout" class="dashboard-container-black">


    <div class="app-header">

      <div style="float:left;height: 50px;">
        <img height="40" style="margin:3px 10px 0px 22px;cursor: pointer;" v-bind:src="logoUrl" @click="TopMenuGoIndex">
        <span id="tk" hidden>{{getStaffCode2()}}</span>
      </div>

      <div style="float: left;" v-if="showTopMenu">
        <div v-for="item in menusTop" v-bind:key="item.url"
             style="float:left;margin: 0px 10px;cursor: pointer;font-size: 14px;color:#C1C6C8;"
             v-on:click="TopMenuGo(item.url,item.menuCode)">
          <span v-if="menuTopCur == item.url" style="color:#fff;">{{ replaceStr(item.name)  }}</span>
          <span v-if="menuTopCur != item.url" >{{ replaceStr(item.name)  }}</span>
        </div>
        <div style="clear:both;"></div>
      </div>


      <audio ref="audio" :src="audioSrc" loop hidden></audio>

      <div style="float: right;margin-right: 10px;height: 50px;color:#C1C6C8;">


        <span class="top-text" style="margin-right: 20px;color:red;" v-if="showPhoneOut&&duerRtc==null">
          <i class="el-icon-link" title="小度连接失败"></i>
        </span>

        <span class="top-text" style="margin-right: 20px" v-if="showVisualOut">
          <i class="el-icon-video-camera"></i>
          <span @click="goVisual">大屏系统</span>
        </span>

        <span class="top-text" style="margin-right: 10px">
          <i class="el-icon-s-custom"></i>
          <span @click="dialogStaffInfoShow=true">
            {{staffDTO.loginName}}『{{staffDTO.roleName}}』
          </span>
        </span>

        <el-tooltip effect="dark" :content='showBell?"已开启":"已关闭"'
                    v-if="showBellOut" placement="bottom">
          <span style="margin-right: 20px;height: 50px;cursor: pointer;" v-on:click="getBell">
            <span class="top-text">
              <i class="el-icon-close-notification" v-show="!showBell"></i>
              <i class="el-icon-bell" v-show="showBell"></i>
              <span> 报警铃声</span>
            </span>
          </span>
        </el-tooltip>

        <span style="position: relative;height: 50px;display: inline-block;margin-right: 20px;" @mouseleave="setPhoneHidden()" v-if="showPhoneOut">

                <span class="top-text" @mouseenter="setPhoneVisible()">
                  <span>手机APP</span>
                  <i class="el-icon-caret-bottom"></i>
                </span>

                <transition name="fade">
                  <div class="set-dropdown" style="width: 320px;" v-if="showPhone">

                    <div style="text-align: center;color:#fff;">用浏览器扫码下载</div>

                     <div>
                      <div style="float:left;">
                        <div class="set-dropdown-inner">

                          <div style="background-color: #fff;padding: 5px;">
                            <div id="qrcode_lrd" style="width: 110px;height: 110px;"></div>
                            <div style="clear:both;"></div>
                          </div>
                          <div style="text-align: center;color:#fff;">长者端</div>


                           <div style="background-color: #fff;padding: 5px;">
                            <div id="qrcode_gzd" style="width: 110px;height: 110px;"></div>
                            <div style="clear:both;"></div>
                          </div>
                          <div style="text-align: center;color:#fff;">适老改造端</div>


                        </div>
                      </div>
                      <div style="float:left;">
                        <div class="set-dropdown-inner">

                          <div style="background-color: #fff;padding: 5px;">
                            <div id="qrcode_fwd" style="width: 110px;height: 110px;"></div>
                            <div style="clear:both;"></div>
                          </div>
                          <div style="text-align: center;color:#fff;">服务端</div>

                          <div style="background-color: #fff;padding: 5px;">
                            <div id="qrcode_syd" style="width: 110px;height: 110px;"></div>
                            <div style="clear:both;"></div>
                          </div>
                          <div style="text-align: center;color:#fff;">收银端</div>


                        </div>
                      </div>

                      <div style="clear:both;"></div>
                    </div>

                  </div>
                </transition>

              </span>

        <span style="position: relative;height: 50px;display: inline-block;margin-right: 10px;" @mouseleave="setMoreHidden()">

          <span class="top-text" @mouseenter="setMoreVisible()">
            <span>设置</span>
            <i class="el-icon-caret-bottom"></i>
          </span>

          <transition name="fade">
            <div class="set-dropdown" v-if="showSet">
              <div class="set-dropdown-inner">

                <div class="set-item" @click="dialogPwdShow = true">
                  <i class="el-icon-s-check"></i>
                  <span style="margin-left: 10px;">修改密码</span>
                </div>
                <div class="set-item" @click="loginOut">
                   <i class="el-icon-turn-off"></i>
                  <span style="margin-left: 10px;">退出</span>
                </div>
              </div>
            </div>
          </transition>

        </span>

      </div>

      <div style="clear: both"></div>
    </div>

    <div class="app-content" :style="contentStyleObj">
      <div class="app-nav" :style="contentStyleObj" v-if="leftMenusShow">
        <app-nav v-bind:isCollapse="isCollapse"></app-nav>
      </div>
      <div class="app-wrap" style="position: relative">
        <div :style="contentStyleObj2" @click="menuTag" v-if="leftMenusShow">
          <img width="10" height="40" style="margin:3px 0px;" v-bind:src="menuTagImg">
        </div>
        <transition name="fade" mode="out-in">
          <router-view/>
        </transition>
      </div>
    </div>


    <el-dialog title="密码修改" :visible.sync="dialogPwdShow" class="dialog" width='400px' center top='30vh' :close-on-click-modal='false'>
      <el-input v-model="oldPassword" placeholder="请输入旧密码" maxlength="20" minlength="6" show-password></el-input>
      <div style="height: 10px;"></div>
      <el-input v-model="newPassword" placeholder="请输入新密码" maxlength="20" minlength="6" show-password></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogPwdShow=false">取 消</el-button>
        <el-button type="primary"  @click="editPasswordSure">提交</el-button>
      </div>
    </el-dialog>

    <el-dialog title="用户信息" :visible.sync="dialogStaffInfoShow" class="dialog" width='700px' center
               top='30vh' :close-on-click-modal='false'>

      <el-row class="row">
        <el-col :span="12" class="item">
          <div class="label">登录名：{{this.staffDTO.loginName}}</div>
        </el-col>
        <el-col :span="12" class="item">
          <div class="label">角色：{{this.staffDTO.roleName}}</div>
        </el-col>
      </el-row>

      <el-row class="row">
        <el-col :span="12" class="item">
          <div class="label">真实姓名：{{this.staffDTO.realName}}</div>
        </el-col>
        <el-col :span="12" class="item">
          <div class="label">手机：{{this.staffDTO.phone}}</div>
        </el-col>
      </el-row>

      <el-row class="row">
        <el-col :span="12" class="item">
          <div class="label">政府：
            <span v-if="this.staffDTO.governmentDTO != null">{{this.staffDTO.governmentDTO.name}}[{{this.staffDTO.zoneName}}]</span>
          </div>
        </el-col>
        <el-col :span="12" class="item" v-if="this.staffDTO.businessDTO != null">
          <el-col :span="12" class="item" v-if="this.staffDTO.businessDTO != null">
            <div class="label">商家：{{this.staffDTO.businessDTO.userDTO.name}}
              <span v-if="this.staffDTO.businessDTO.businessType==1">[家政服务商]</span>
              <span v-if="this.staffDTO.businessDTO.businessType==2">[积分兑换商]</span>
              <span v-if="this.staffDTO.businessDTO.businessType==3">[社区食堂商]</span>
            </div>
          </el-col>
        </el-col>
      </el-row>

    </el-dialog>


    <ViewCamera ref="myViewCamera" v-show="showCamera" v-on:closeCamera="showCamera=false"></ViewCamera>
    <ViewCameraPlus ref="myViewCameraPlus" v-show="showCameraPlus" v-on:closeCameraPlus="showCameraPlus=false"></ViewCameraPlus>


    <el-dialog title="老人信息" :visible.sync="showModalInfo" class="dialog" width='1000px'
               center top='10vh' :close-on-click-modal='false'>
      <InfoMain ref="myInfoMain"></InfoMain>
    </el-dialog>



    <!-- 来电弹窗 -->
    <div role="dialog" class="modal2 fade" id="incoming-call-dialog" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="usr-info">
              <img class="usr-pho" src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-7/1658388218664/pho.png">
              <!--用于来电展示，接入方通过来电sn查询获取来电姓名 -->
              <!--              <p class="usr-name">未知来电</p>-->
              <p class="usr-name">来电人：{{callUserName}}</p>
              <p class="incoming-call-tip">邀请您通话</p>
            </div>
            <div class="op-btns">
              <div class="incoming-call-reject">
                <img
                    onclick="rejectCall()"
                    src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661433175110/reject.png"
                >
                <p class="op-txt">挂断</p>
              </div>
              <div class="incoming-call-video">
                <img
                    onclick="answerCall(0)"
                    src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661433226356/videoCall.png"
                >
                <p class="op-txt">视频通话</p>
              </div>
              <div class="incoming-call-audio">
                <img
                    onclick="answerCall(1)"
                    src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661433255465/audioCall.png"
                >
                <p class="op-txt">语音通话</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 去电响铃 -->
    <div id="outing-call-view" style="display: none;">
      <div class="peer-info">
        <img class="peer-pho" src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-7/1658388218664/pho.png">
        <!-- 业务方根据实际呼叫用户进行替换 -->
        <p class="peer-name">被叫名字</p>
        <p class="outing-call-tip">设备正在响铃中，请不要挂断...</p>
      </div>
      <div class="op-btns">
        <div class="out-call-mode">
          <img
              onclick="changeMode()"
              src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661828922567/videoCall0.png"
          >
          <p class="out-call-mode-txt">视频呼叫</p>
        </div>
        <!-- <div class="out-call-mode">
            <img
                onclick="changeMode()"
                src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515364706/audio000.png"
            >
            <p>语音呼叫</p>
        </div> -->
        <div>
          <img
              onclick="dropCall()"
              src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661433175110/reject.png"
          >
          <p style="color: #E24940">挂断</p>
        </div>
      </div>
    </div>

    <!-- 通话界面 -->
    <div id="call-view" style="display: none;">
      <div class="peer-view main-view">
        <video id='video-peer' autoPlay></video>
        <audio id='audio-peer' autoPlay></audio>
        <div class="audio-tip-wrap">
          <!-- <p class="audio-name online-ellipsis">对端姓名</p> -->
          <p class="audio-call">语音通话中</p>
        </div>
      </div>
      <div class="local-view sub-view">
        <video id='video-local' autoPlay></video>
        <audio id='audio-local' autoPlay></audio>
        <div class="audio-tip-wrap">
          <p class="audio-name online-ellipsis">本机</p>
          <p class="audio-call">语音通话中</p>
        </div>
      </div>
      <div class="op-btns">
        <div class="mute-change-btn">
          <img
              onclick="changeMute()"
              src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515279806/quite0.png"
          >
          <p class="a-mute">静音</p>
        </div>
        <!-- <div>
            <img
                onclick="changeAudioMute"
                src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515279209/quite.png"
            >
            <p class="a-mute">已静音</p>
        </div> -->
        <div class="mode-change-btn">
          <img
              onclick="changeMode()"
              src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661828922567/videoCall0.png"
          >
          <p class="v-mode">视频通话</p>
        </div>
        <!-- <div>
            <img
                onclick="changeMode"
                src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515364706/audio000.png"
            >
            <p>语音通话</p>
        </div> -->
        <div>
          <img
              onclick="dropCall()"
              src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661433175110/reject.png"
          >
          <p style="color: #E24940">挂断</p>
        </div>
      </div>
    </div>
    <audio id="ring-music" loop>
      <source src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-9/1662024495462/ring_new.mp3" type="audio/mpeg">
    </audio>
    <div class="alert alert-warning fade in" id="message-alert">
      <a href="#" class="close" data-dismiss="alert">
        &times;
      </a>
      <span class="call-message">呼叫超时，请稍后再试</span>
    </div>





  </div>
</template>

<script>

import AppNav from './AppNav';
import ViewCamera from "@/views/Device/Camera/Comm/ViewCamera2";
import ViewCameraPlus from "@/views/Device/Camera/Comm/ViewCameraPlus";
import InfoMain from "@/views/Elderly/Info/Main";


import {getStaffCode, removeToken, getToken, replaceStr, getToken2,getGovernmentCode} from '@/utils/auth'
import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import menuTagImgToLeft from "../assets/menuTag.png";
import menuTagImgToRight from "../assets/menuTag2.png";

import {
  govRoleName, superviseRoleName, superRoleName, logoUrl,
  visualTitle, zoneRoleName, insRoleName, systemRoleName
} from "@/common/const";

import QRCode from "qrcodejs2";

export default {
  name: 'IndexNew',
  components: {
    AppNav,ViewCamera,ViewCameraPlus,InfoMain
  },
  data(){
    return{

      showSet:false,
      dialogPwdShow:false,
      dialogStaffInfoShow:false,
      showCamera:false,
      showCameraPlus:false,

      showPhone:false,
      showPhoneOut:false,

      showVisualOut:false,
      showBellOut:false,
      showTopMenu:true,


      staffDTO:JSON.parse(getToken()),
      isCollapse:false,
      leftMenusShow:true,
      showBell:true,

      menuTagImg:menuTagImgToLeft,

      contentStyleObj: {
        height: '',
        flexBasis:'200px',
      },

      contentStyleObj2: {
        width:'20px',
        height:'50px',
        position: 'absolute',
        top:'',
        left:'0px',
        cursor: 'pointer'
      },

      menusTop:this.$store.state.listMenuTop,
      menuTopCur:'',
      currentInstitutionCode:'',
      currentInstitutionName:'',

      oldPassword:'',
      newPassword:'',
      getToken:getToken(),
      flag:true,
      audioSrc:require('@/assets/baojing.mp3'),
      staffCode:"",

      path: this.$websocketUrl,
      socket:"",
      audio:"",
      setTimeoutPaused:'',
      lockReconnect: false,//是否真正建立连接
      timeout: 30*1000,//30秒一次心跳
      timeoutObj: null,//心跳心跳倒计时
      serverTimeoutObj: null,//心跳倒计时
      timeoutnum: null,//断开 重连倒计时
      timeAxiosWS:null,//定时请求

      logoUrl:logoUrl,
      visualTitle:visualTitle,

      intervalId:null,
      intervalVersion:null,
      alarmPhone:[],

      showModalInfo:false,

      duerRtcSdk:null,
      duerRtc:null,
      callInfo : {},
      callUserName:'',

    }
  },
  created(){

    this.leftMenusShow = true;
    this.alarmPhone = [];


    var getToken=JSON.parse(this.getToken)
    this.staffCode = getToken.staffCode;
    if(getToken.roleName == superRoleName){
      this.showTopMenu = false;
    }
    if(getToken.roleName == systemRoleName){
      this.path = this.path+this.staffCode+'|'+ new Date().getTime();
      this.websocketInit();
      this.showBellOut = true;
      this.showVisualOut = true;
    }
    if(getToken.roleName==govRoleName){
      this.path = this.path+this.staffCode+'|'+ new Date().getTime();
      this.websocketInit();

      this.showPhoneOut = true;
      this.showBellOut = true;
      this.showVisualOut = true;

    }
    if(getToken.roleName == zoneRoleName){
      this.path = this.path+this.staffCode+'|'+ new Date().getTime();
      this.websocketInit();
      this.showVisualOut = true;
    }
    if(getToken.roleName == insRoleName){
      this.path = this.path+this.staffCode+'|'+ new Date().getTime();
      this.websocketInit();
    }
    if(getToken.roleName == superviseRoleName){
      this.showVisualOut = true;
    }




    let listMenuDTO = JSON.parse(window.localStorage.getItem('listMenuDTO'));
    if(listMenuDTO == null||listMenuDTO == 'null'){
      this.getListMenu();
    }
    else{

      let listMenuDTO = JSON.parse(window.localStorage.getItem('listMenuDTO'));
      this.$store.commit('update', ['listMenuDTO',listMenuDTO]);

      let listMenuTop = JSON.parse(window.localStorage.getItem('listMenuTop'));
      this.$store.commit('update', ['listMenuTop',listMenuTop]);


      let listMenuLeft = JSON.parse(window.localStorage.getItem('listMenuLeft'));
      this.$store.commit('update', ['listMenuLeft',listMenuLeft]);

      let activeMenuTop = window.localStorage.getItem('activeMenuTop');
      this.$store.commit('update', ['activeMenuTop',activeMenuTop]);
      this.menuTopCur=activeMenuTop

    }


    this.getHight();
    window.addEventListener('resize', this.getHight);


    //刷新页面恢复左侧导航到刷新前到状态
    this.isCollapse = window.localStorage.getItem("isCollapse") === 'true';
    if(this.isCollapse){
      this.contentStyleObj.flexBasis = 64 + 'px'
      this.menuTagImg = menuTagImgToRight;
    }
    else{
      this.contentStyleObj.flexBasis = 200 + 'px'
      this.menuTagImg = menuTagImgToLeft;
    }


    this.intervalId = setInterval(() => {

      let that = this;

      let tk = "";
      const hasToken = getToken2();
      if(hasToken){
        let staffDTO = JSON.parse(getToken2());
        tk = staffDTO.staffCode;
      }


      let tk2 = document.getElementById("tk").innerText;

      //console.log(tk2,tk);

      if(tk2 != tk){

        clearInterval(that.intervalId); //清除计时器
        that.intervalId = null; //设置为null

        console.log("login change");

        this.$confirm('登录已改变?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose:false,
          showCancelButton:false,
          closeOnClickModal:false,
          type: 'warning'
        }).then(() => {

          removeToken();
          window.localStorage.setItem('activeInstitutionCode', null);
          window.localStorage.setItem('activeStaffCode', null);
          window.localStorage.setItem('activeMenuTop', null);
          window.localStorage.setItem('listMenuDTO', null);
          window.localStorage.setItem('listMenuTop', null);
          window.localStorage.setItem('listMenuLeft', null);
          window.localStorage.setItem('isHome', null);
          this.$store.commit('update', ['loginToken',null]);
          if(this.staffDTO.roleName=="政府管理员"){
            console.log(this.socket)
            if(this.socket){
              this.destroyed()
              clearTimeout(this.timeoutObj);
              clearTimeout(this.serverTimeoutObj);
              clearTimeout(this.timeAxiosWS);
              this.lockReconnect = true;
            }
          }
          this.$router.push({ path: '/login' })


        }).catch(e=>e)


      }


    }, 100);


    this.checkVersion();
    this.intervalVersion = setInterval(() => {
      let that = this;
      that.checkVersion();
    }, 1000*60*5);



    window.changeMute = this.changeMute;
    window.changeMode = this.changeMode;
    window.dropCall = this.dropCall;
    window.rejectCall = this.rejectCall;
    window.answerCall = this.answerCall;
    this.getToken2();

  },

  destroyed() {

    window.removeEventListener('resize', this.getHight)

    clearInterval(this.intervalId); //清除计时器
    this.intervalId = null; //设置为null

    clearInterval(this.intervalVersion);
    this.intervalVersion = null;

  },

  watch: {

    //监听局部变量
    activeMenuTop(newValue, oldValue) {
      console.log(newValue+"--"+oldValue)
    },

    //监听全局变量
    '$store.state.listMenuTop' : function(val){
      this.menusTop = val;
    },
    '$store.state.activeMenuTop' : function(val){
      this.menuTopCur = val;
    },

  },

  methods:{


    async checkVersion() {
      const currentVersion = require('@/../public/version.json').version;
      //console.log("-1-"+currentVersion);
      try {
        const res = await fetch('/version.json?t=' + Date.now());
        const { version } = await res.json();
        //console.log("-2-"+version);
        if (version !== currentVersion) {

          console.log("重新加载网页");

          window.location.reload();

        }
      } catch (e) {
        console.error('版本检测失败', e);
      }
    },


    getToken2(){

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceXDu/getUidToken2",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          governmentCode:getGovernmentCode(),
        },
      }).then((response) => {
        //console.log(response);
        if (response.data.error == 0) {
          let uid = response.data.data.uid;
          let rtc_appid = response.data.data.rtc_appid;
          let token = response.data.data.token;

          this.initSocket(uid,rtc_appid,token);

        } else if (response.data.error == 1) {
          console.log(response.data.message);
          //this.$message.error(response.data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });

    },

    initSocket(uid,appId,token){

      let enbaleRtcDebugLog = true;

      let appName = "appName";
      //let uid = "uid40001730";
      //let appId = "fw05ci27";
      //let token = "12002-fw05ci27ZSJcaGUo8-hMI-rmAAt1aWQ0MDAwMTczMAAQfd-sfVd3ihmCevlS-ru_BQ==";

      // sdk挂载的⽅法
      const duerRtcSdk = window.DUER_rtcsdk;

      // 初始化rtc对象
      const duerRtc = new duerRtcSdk.RtcContext ({ onAuthStatusChanged: auth => {
          // 鉴权状态发⽣变化回调，对不同状态auth.code做分别处理
          //5000表示鉴权通过，可在此处进⾏⼊席操作duerRtc.enableCustomer(true);
          // auth.code常⽤值⻅下⾯的常⽤值部分


          console.log(auth);
          if(auth.code == 5000){
            console.log(11111);
            duerRtc.enableCustomer(true);
          }


        },
      }, enbaleRtcDebugLog); // 是否打印⽇志，建议线下调试设置为true，上线设置为false

      // 构造参数建⽴⻓连接参数
      /**
       *uri RTC呼叫系统唯⼀标识定义
       *@param uid 应⽤⽤户唯⼀标识
       *@param appId 应⽤程序唯⼀标识，这⾥是rtc_appid，邮件分配的
       */
      const uri = new duerRtcSdk.CallUri(uid, appId); const loginParams = {
        uri: uri, uid: uid, appId: appId,
        appName: appName, token: token
      };

      // 建⽴⻓连接
      duerRtc.login(loginParams);

      this.duerRtc = duerRtc;
      this.duerRtcSdk = duerRtcSdk;
      this.callInfo = {
        mute: false,
        mode: duerRtcSdk.CallMode.AUDIO_VIDEO
      };

      this.setListener();

    },


    setListener(){

      this.duerRtc.setCallListener({
        onIncomingCall: intent => {
          const serviceInfo = intent.serviceInfo && JSON.parse(intent.serviceInfo) || {};
          intent.serviceInfo = serviceInfo;
          Object.assign(this.callInfo, intent);
          this.incomingViewShow();
          console.log("onIncomingCall", intent);

          let sn = serviceInfo.sn;
          this.getDeviceInfo(sn);

        },
        onAddConfereeStateChanged: state => {
          console.log("onAddConfereeStateChanged", state);
        },
        onCallReplaced: replaced => {
          console.log("onCallReplaced", replaced);
        },
        onCallStateChanged: stateInfo => {
          if (stateInfo.state === this.duerRtcSdk.CallState.RINGBACK) {
            // 被叫开始响铃
            this.ringViewShow();
          }
          else if (stateInfo.state === this.duerRtcSdk.CallState.DISCONNECTED) {
            // 通话已经断开
            this.freeCallView();
            if (stateInfo.reason === this.duerRtcSdk.CallReason.TIMEOUT) {
              // 呼叫超时
              this.callTimeout();
            }
          }
          else if (stateInfo.state === this.duerRtcSdk.CallState.CONNECTED) {
            // 通话被正常接听
            this.callViewShow();
          }
          console.log("onCallStateChanged", stateInfo);
        },
        onConfereeLayout: layouts => {
          this.setLayouts(layouts);
          console.log("onConfereeLayout", layouts);
        },
        onRecordStateChanged: recordStateInfo => {
          console.log("onRecordStateChanged", recordStateInfo);
        }
      });

      this.duerRtc.setConnectListener({
        onConnectionChanged: conn => {
          if (conn === 2) {
            // 长链接已建立
            //$('#login-form').hide();
            //$('#device-form').show();
            //this.$message.success("小度连接成功");
          }
          if (conn === 3) {
            // 长链接已断开
            this.duerRtc = null;

            //this.$message.warning("小度连接失败");
            //this.getToken2();

          }
          console.log("onConnectionChanged", conn);
        }
      });

      this.duerRtc.setMediaDeviceListener({
        // 麦克风/摄像头状态
        onMediaDeviceStateChanged: (device, state, error) => {
          console.log('onMediaDeviceStateChanged', device, state, error);
        }
      });


    },

    getDeviceInfo(imei){

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceXDu/InfoByImei",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          imei: imei,
        },
      }).then((response) => {
        console.log(response);
        if (response.data.error == 0) {
          let userDevice = response.data.data.userDevice;
          this.callUserName = userDevice.userName;
        }
      }).catch(function (error) {
        console.log(error);
      });

    },


    willCall(row,type){

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceXDu/getCallAddressAppIdNumber2",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          sn:row.imei,
          isDuerNumber:true,
          governmentCode:getGovernmentCode(),
        },
      }).then((response) => {
        //console.log(response);
        if (response.data.error == 0) {
          let callAppId = response.data.data.callAppId;//appid
          let callAddress = response.data.data.callAddress;//uid

          this.makeCall(callAppId,callAddress,type);//0：视频，1：语音

        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });


    },

    // 呼叫
    makeCall(appId, uid, callMode, callerRole = this.duerRtcSdk.CallerRole.CALL_CENTER) {
      const calleeUri = new this.duerRtcSdk.CallUri(uid, appId);
      let intent = this.duerRtcSdk.MakeCallIntent(calleeUri, this.duerRtcSdk.CallMode.AUDIO_VIDEO);
      callMode && (intent.callMode = callMode);
      callerRole && (intent.callerRole = callerRole);
      this.callInfo.callMode = callMode;
      const result = this.duerRtc.makeCall(intent)
      console.info('makeCall action', intent, result)
      if (this.duerRtcSdk.CallReason.NORMAL == result) {
        // 呼出成功

        setInterval(_ => {
          this.getDevice();
        }, 10000);

      } else if (this.duerRtcSdk.CallReason.ALREADY_IN_CALL == result || this.duerRtcSdk.CallReason.EXCEPTION_INPUT_ILLEGAL == result) {
        console.error('makeCall resaon', this.duerRtcSdk.CallReasonMap.get(result))
      }
      else {
        // 其他原因，目前不会出现
        console.warn('makeCall res', result)
      }
    },
    // 来电接听
    answerCall(mode) {
      this.duerRtc.answerCall(this.callInfo.index, mode, false);
      this.callInfo.callMode = mode;
    },
    // 拒接来电
    rejectCall() {
      this.duerRtc.rejectIncomingCall(this.callInfo.index, 'REJECT_CALL_USER_REASON');
    },
    // 改变通话模式 type 1去电  2通话中
    changeMode() {
      const mode = this.callInfo.callMode == this.duerRtcSdk.CallMode.AUDIO_VIDEO
          ? this.duerRtcSdk.CallMode.AUDIO_ONLY
          : this.duerRtcSdk.CallMode.AUDIO_VIDEO;
      console.log(mode, this.callInfo.callMode);
      if (mode == this.duerRtcSdk.CallMode.AUDIO_VIDEO) {
        $('.out-call-mode img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515364706/audio000.png');
        $('.out-call-mode-txt').text('语音通话');
        $('.mode-change-btn img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515364706/audio000.png');
        $('.v-mode').text('语音通话');
        $('.audio-tip-wrap').hide();
      } else if (mode == this.duerRtcSdk.CallMode.AUDIO_ONLY) {
        $('.out-call-mode img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661828922567/videoCall0.png');
        $('.out-call-mode-txt').text('视频通话');
        $('.mode-change-btn img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661828922567/videoCall0.png');
        $('.v-mode').text('视频通话');
        $('.audio-tip-wrap').show();
      }
      this.duerRtc.changeCallMode(mode);
      this.callInfo.callMode = mode;
    },
    // 静音状态切换
    changeMute() {
      if (this.callInfo.mute) {
        $('.mute-change-btn img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515279806/quite0.png');
        $('.a-mute').text('静音');
      } else {
        $('.mute-change-btn img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515279209/quite.png');
        $('.a-mute').text('已静音');
      }
      this.callInfo.mute = !this.callInfo.mute;
      this.duerRtc.muteAudio(this.callInfo.mute);
    },
    // 挂断通话
    dropCall() {
      this.duerRtc.dropCall('DROP_CALL_USER_REASON');
    },
    // 设置音视频
    setLayouts(layouts) {
      if (!layouts) {
        return;
      }

      const audioLocal = document.getElementById('audio-local');
      const videoLocal = document.getElementById('video-local');
      const audioPeer = document.getElementById('audio-peer');
      const videoPeer = document.getElementById('video-peer');
      const [layoutLocal, layoutPeer] = layouts;
      if (layoutLocal.videoTrack) {
        $('#video-local').show();
        $('.local-view .audio-tip-wrap').hide();
        const stream = new MediaStream;
        stream.addTrack(layoutLocal.videoTrack);
        videoLocal.srcObject = stream;
      }
      else {
        $('#video-local').hide();
        $('.local-view .audio-tip-wrap').show();
      }
      if (layoutLocal.audioTrack && !layoutLocal.isLocal) {
        const stream = new MediaStream;
        stream.addTrack(layoutLocal.audioTrack);
        audioLocal.srcObject = stream;
      }
      if (layoutPeer.videoTrack) {
        $('#video-peer').show();
        $('.peer-view .audio-tip-wrap').hide();
        const stream = new MediaStream;
        stream.addTrack(layoutPeer.videoTrack);
        videoPeer.srcObject = stream;
      }
      else {
        $('#video-peer').hide();
        $('.peer-view .audio-tip-wrap').show();
      }
      if (layoutPeer.audioTrack) {
        const stream = new MediaStream;
        stream.addTrack(layoutPeer.audioTrack);
        audioPeer.srcObject = stream;
      }

    },
    // 视频大小窗口切换事件
    changeView() {
      $('.peer-view').click(_ => {
        const cList = $('.peer-view').attr('class');
        if (~cList.indexOf('sub-view')) {
          $('.peer-view').attr('class', 'peer-view main-view');
          $('.local-view').attr('class', 'local-view sub-view');
        }
      });
      $('.local-view').click(_ => {
        const cList = $('.local-view').attr('class');
        if (~cList.indexOf('sub-view')) {
          $('.local-view').attr('class', 'local-view main-view');
          $('.peer-view').attr('class', 'peer-view sub-view');
        }
      });
    },
    // 去电响铃时界面展示
    ringViewShow() {
      $('#ring-music').get(0).play();
      $('.peer-name').text(this.callInfo.name);
      if (this.callInfo.callMode == this.duerRtcSdk.CallMode.AUDIO_VIDEO) {
        // 当前为视频通话
        $('.out-call-mode img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515364706/audio000.png');
        $('.out-call-mode-txt').text('语音通话');
      } else if (this.callInfo.callMode == this.duerRtcSdk.CallMode.AUDIO_ONLY) {
        // 当前为音频通话
        $('.out-call-mode img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661828922567/videoCall0.png');
        $('.out-call-mode-txt').text('视频通话');
      }
      $('#outing-call-view').show();
    },
    // 收到来电
    incomingViewShow() {
      $('#incoming-call-dialog').modal('show');
      $('#ring-music').get(0).play();
    },
    // 空闲状态
    freeCallView() {
      $('#outing-call-view').hide();
      $('#call-view').hide();
      $('#incoming-call-dialog').modal('hide');
      $('#ring-music').get(0).pause();
      Object.assign(this.callInfo, {
        mute: false
      });
    },
    // 通话正常接听
    callViewShow() {
      $('#ring-music').get(0).pause();
      $('#incoming-call-dialog').modal('hide');
      $('#outing-call-view').hide();
      if (this.callInfo.mute) {
        // 已静音
        $('.mute-change-btn img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515279209/quite.png');
        $('.a-mute').text('已静音');
      } else {
        $('.mute-change-btn img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515279806/quite0.png');
        $('.a-mute').text('静音');
      }
      if (this.callInfo.callMode == this.duerRtcSdk.CallMode.AUDIO_VIDEO) {
        // 当前为视频通话
        $('.mode-change-btn img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515364706/audio000.png');
        $('.v-mode').text('语音通话');
        $('.audio-tip-wrap').hide();
      } else if (this.callInfo.callMode == this.duerRtcSdk.CallMode.AUDIO_ONLY) {
        // 当前为音频通话
        $('.mode-change-btn img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661828922567/videoCall0.png');
        $('.v-mode').text('视频通话');
        $('.audio-tip-wrap').show();
      }
      $('#call-view').show();
    },
    // 呼叫超时
    callTimeout() {
      $('#outing-call-view').hide();
      $('#message-alert').show();
    },
    // 获取浏览器权限，根据实际情况调用，只限于用户没有做过授权
    getDevice() {
      navigator.getUserMedia = navigator.getUserMedia
          || navigator.webkitGetUserMedia
          || navigator.mozGetUserMedia
          || navigator.msGetUserMedia;
      if (navigator.getUserMedia) {
        navigator.getUserMedia({video: true}, function onSuccess(stream) {
          console.log('摄像头开启成功');
        }, function onError(error) {
          alert("摄像头错误：", error);
        });
        navigator.getUserMedia({audio:true}, function onSuccess(stream) {
          console.log('麦克风开启成功');
        }, function onError(error) {
          alert("麦克风错误：", error);
        });
      }
      else {
        alert('暂不支持');
      }
    },

    // 定时获取摄像头麦克风权限，根据业务实际情况调用
    // 用于定位音视频是否因为权限问题不显示
    // setInterval(_ => {
    //     getDevice();
    // }, 10000);







    getStaffCode2(){

      const hasToken = getToken()
      if(hasToken){
        let staffDTO = JSON.parse(getToken());
        return staffDTO.staffCode;
      }
      else{
        return "";
      }

    },

    replaceStr(name){
      return replaceStr(name);
    },

    goVisual(){
      var getToken=JSON.parse(this.getToken);
      let staffCode = getToken.staffCode;

      //let governmentName = getToken.governmentDTO.name;

      let governmentName = '';
      if(getToken.roleName != systemRoleName){
        governmentName = getToken.governmentDTO.name;
      }

      if(window.location.host == '118.89.66.71:8090'){
        window.open("http://118.89.66.71:8091/#/rd?loginName="+governmentName+"&staffCode="+staffCode
            +"&title="+this.visualTitle, '_blank');
      }
      else{
        window.open(this.$visualUrl+"#/rd?loginName="+governmentName+"&staffCode="+staffCode
            +"&title="+this.visualTitle, '_blank');

        // window.open("http://localhost:8081/#/rd?loginName="+governmentName+"&staffCode="+staffCode
        //     +"&title="+this.visualTitle, '_blank');
      }

    },

    //设置显示
    setMoreVisible(){
      this.showSet = true;
    },
    //设置隐藏
    setMoreHidden(){
      this.showSet = false;
    },

    //手机银秋显示
    setPhoneVisible(){
      this.showPhone = true;
      this.$nextTick(function () {
        if(visualTitle == '银秋智慧养老'){
          this.creatQrcode('qrcode_lrd',this.$imgUrl+"apk/ynnqo/elderly.apk");
          this.creatQrcode('qrcode_sjd',this.$imgUrl+"apk/ynnqo/business.apk");
          this.creatQrcode('qrcode_fwd',this.$imgUrl+"apk/ynnqo/serve.apk");
          this.creatQrcode('qrcode_syd',this.$imgUrl+"apk/ynnqo/cashier.apk");
          this.creatQrcode('qrcode_yhd',this.$imgUrl+"apk/ynnqo/mediciner.apk");
          this.creatQrcode('qrcode_gzd',this.$imgUrl+"apk/ynnqo/reform.apk");
        }else{
          this.creatQrcode('qrcode_lrd',this.$imgUrl+"apk/comm/lrd.apk");
          //this.creatQrcode('qrcode_sjd',this.$imgUrl+"apk/comm/sjd.apk");
          this.creatQrcode('qrcode_fwd',this.$imgUrl+"apk/comm/fwd.apk");
          this.creatQrcode('qrcode_syd',this.$imgUrl+"apk/comm/syd.apk");
          //this.creatQrcode('qrcode_yhd',this.$imgUrl+"apk/comm/yhd.apk");
          this.creatQrcode('qrcode_gzd',this.$imgUrl+"apk/comm/gzd.apk");
        }
      })
    },
    //手机银秋隐藏
    setPhoneHidden(){
      this.showPhone = false;
    },
    creatQrcode(id,url) {
      let obj = document.getElementById(id);
      obj.innerHTML = '';
      var qrcode = new QRCode(obj, {
        text: encodeURI(url),
        width: 110,
        height: 110
      });
    },



    getBell(){
      this.showBell=!this.showBell
      if(this.showBell){
        this.$message.success("已开启报警提示音")
      }else{
        this.$message.error("已关闭报警提示音")
      }
    },
    websocketInit:function(){
      if(typeof(WebSocket) === "undefined"){
        alert("您的浏览器不支持socket")
      }
      else{
        // 实例化socket
        this.socket = new WebSocket(this.path)
        // 监听socket连接
        this.socket.onopen = this.open
        // 监听socket错误信息
        this.socket.onerror = this.error
        // 监听socket消息
        this.socket.onmessage = this.getMessage

        this.socket.onclose=this.close
      }
    },
    open: function () {
      console.log("socket连接成功")
      //开启心跳
      this.start();
    },
    error: function () {
      console.log("连接错误")
      //重连
      if(this.$store.state.loginToken){
        this.reconnect();
      }

    },
    getMessage: function (msg) {
      console.log(msg.data)
      var data=''
      try {
        data=JSON.parse(msg.data);
      } catch(e) {
        data=false;
      }

      if(data){
        var that=this
        const h = this.$createElement;
        var title=''
        clearTimeout(that.setTimeoutPaused);
        this.playAudio(1)

        var messageList=[]

        if(data.type==2 || data.type==3 || data.type==4
            || data.type==5 || data.type==6 || data.type==9
            || data.type==10 || data.type==13){
          title='安防报警('+data.typeTitle+')';

          messageList.push(h('span',null , "用户："+data.user.name),h('br', null, null))
          messageList.push(h('span',null , "手机号："+data.user.phone),h('br', null, null))
          messageList.push(h('span',null , "报警时间："+data.sendTime),h('br', null, null))
          messageList.push(h('span',null , "所在小区："+data.zoneCodePathName),h('br', null, null))
          messageList.push(h('span',null , "经纬度(住址)："+data.lon+","+data.lat),h('br', null, null))
          messageList.push(h('span',null , "家庭住址："+data.address),h('br', null, null))

          if(data.user.userType==1){
            messageList.push(h('button',{
              on:{click:()=>{ this.handleElderlyInfo({'userCode':data.userCode,'elderlyCode':data.elderlyCode});}},
              style:{'margin-right':'5px',}
            }, "用户信息"));
          }
          if(data.deviceCameraCode){
            messageList.push(h('button',{
              on:{click:()=>{this.viewCamera(data.sn,data.deviceCameraCode);}},
              style:{'margin-right':'5px',}
            }, "查看监控"));
            // messageList.push(h('button',{
            //   on:{click:()=>{this.viewCameraPlus(data.sn,data.deviceCameraCode,data.yzm,data.tdh);}},
            //   style:{'margin-right':'5px',}
            // }, "视频对讲"));
          }

        }
        else if(data.type==7){
          title='睡倍健报警('+data.typeTitle+')';

          messageList.push(h('span',null , "用户："+data.user.name),h('br', null, null))
          messageList.push(h('span',null , "手机号："+data.user.phone),h('br', null, null))
          messageList.push(h('span',null , "报警时间："+data.sendTime),h('br', null, null))
          messageList.push(h('span',null , "所在小区："+data.zoneCodePathName),h('br', null, null))
          messageList.push(h('span',null , "经纬度(住址)："+data.lon+","+data.lat),h('br', null, null))
          messageList.push(h('span',null , "家庭住址："+data.address),h('br', null, null))

          if(data.user.userType==1){
            messageList.push(h('button',{
              on:{click:()=>{ this.handleElderlyInfo({'userCode':data.userCode,'elderlyCode':data.elderlyCode});}},
              style:{'margin-right':'5px',}
            }, "用户信息"));
          }
          if(data.deviceCameraCode){
            messageList.push(h('button',{
              on:{click:()=>{this.viewCamera(data.sn,data.deviceCameraCode);}},
              style:{'margin-right':'5px',}
            }, "查看监控"));
            // messageList.push(h('button',{
            //   on:{click:()=>{this.viewCameraPlus(data.sn,data.deviceCameraCode,data.yzm,data.tdh);}},
            //   style:{'margin-right':'5px',}
            // }, "视频对讲"));
          }

        }
        else if(data.type==77){

          //not use

          title='生命体征检测带预警'
          var notifyTypeList=['心率异常','呼吸异常','离床','呼吸暂停']
          messageList.push(h('span',null , "用户："+data.user.name),h('br', null, null))
          messageList.push(h('span',null , "设备号："+data.warnInfo.mac),h('br', null, null))
          messageList.push(h('span',null , "预警类型："+notifyTypeList[data.warnInfo.notifyType]),h('br', null, null))
          messageList.push(h('span',null , "预警开始时间："+timefilters(data.warnInfo.start)),h('br', null, null))
          messageList.push(h('span',null , "预警结束时间："+timefilters(data.warnInfo.stop)),h('br', null, null))
          if((data.warnInfo.value>=1||data.warnInfo.value<=-1)&&data.warnInfo.notifyType<2){
            messageList.push(h('span',null , "心率呼吸预警状态："+data.warnInfo.value>=1?'过快':'过慢'),h('br', null, null))
          }

        }
        else if(data.type==8){
          title='手表报警('+data.typeTitle+')';

          messageList.push(h('span',null , "用户："+data.user.name),h('br', null, null))
          messageList.push(h('span',null , "手机号："+data.user.phone),h('br', null, null))
          messageList.push(h('span',null , "报警时间："+data.sendTime),h('br', null, null))
          messageList.push(h('span',null , "所在小区："+data.zoneCodePathName),h('br', null, null))
          messageList.push(h('span',null , "经纬度："+data.lon+","+data.lat),h('br', null, null))
          messageList.push(h('span',null , "报警地点："+data.address),h('br', null, null))

          if(data.user.userType==1){
            messageList.push(h('button',{
              on:{click:()=>{ this.handleElderlyInfo({'userCode':data.userCode,'elderlyCode':data.elderlyCode});}},
              style:{'margin-right':'5px',}
            }, "用户信息"));
          }
          if(data.deviceCameraCode){
            messageList.push(h('button',{
              on:{click:()=>{this.viewCamera(data.sn,data.deviceCameraCode);}},
              style:{'margin-right':'5px',}
            }, "查看监控"));
            // messageList.push(h('button',{
            //   on:{click:()=>{this.viewCameraPlus(data.sn,data.deviceCameraCode,data.yzm,data.tdh);}},
            //   style:{'margin-right':'5px',}
            // }, "视频对讲"));
          }

        }
        else if(data.type==11){
          title='健康报警('+data.typeTitle+')';

          messageList.push(h('span',null , "用户："+data.user.name),h('br', null, null))
          messageList.push(h('span',null , "手机号："+data.user.phone),h('br', null, null))
          messageList.push(h('span',null , "报警时间："+data.sendTime),h('br', null, null))
          messageList.push(h('span',null , "所在小区："+data.zoneCodePathName),h('br', null, null))
          //messageList.push(h('span',null , "经纬度："+data.lon+","+data.lat),h('br', null, null))
          messageList.push(h('span',null , "报警地点："+data.address),h('br', null, null))

        }
        else if(data.type==12){
          title='App一键求助';

          messageList.push(h('span',null , "用户："+data.user.name),h('br', null, null))
          messageList.push(h('span',null , "手机号："+data.user.phone),h('br', null, null))
          messageList.push(h('span',null , "报警时间："+data.sendTime),h('br', null, null))
          messageList.push(h('span',null , "所在小区："+data.zoneCodePathName),h('br', null, null))
          messageList.push(h('span',null , "经纬度(住址)："+data.lon+","+data.lat),h('br', null, null))
          messageList.push(h('span',null , "家庭住址："+data.address),h('br', null, null))

          if(data.user.userType==1){
            messageList.push(h('button',{
              on:{click:()=>{ this.handleElderlyInfo({'userCode':data.userCode,'elderlyCode':data.elderlyCode});}},
              style:{'margin-right':'5px',}
            }, "用户信息"));
          }
          if(data.deviceCameraCode){
            messageList.push(h('button',{
              on:{click:()=>{this.viewCamera(data.sn,data.deviceCameraCode);}},
              style:{'margin-right':'5px',}
            }, "查看监控"));
            // messageList.push(h('button',{
            //   on:{click:()=>{this.viewCameraPlus(data.sn,data.deviceCameraCode,data.yzm,data.tdh);}},
            //   style:{'margin-right':'5px',}
            // }, "视频对讲"));
          }

        }
        else if(data.type==14){
          title='跌倒报警';

          messageList.push(h('span',null , "用户："+data.user.name),h('br', null, null))
          messageList.push(h('span',null , "手机号："+data.user.phone),h('br', null, null))
          messageList.push(h('span',null , "报警时间："+data.sendTime),h('br', null, null))
          messageList.push(h('span',null , "所在小区："+data.zoneCodePathName),h('br', null, null))
          messageList.push(h('span',null , "经纬度(住址)："+data.lon+","+data.lat),h('br', null, null))
          messageList.push(h('span',null , "家庭住址："+data.address),h('br', null, null))

          if(data.user.userType==1){
            messageList.push(h('button',{
              on:{click:()=>{ this.handleElderlyInfo({'userCode':data.userCode,'elderlyCode':data.elderlyCode});}},
              style:{'margin-right':'5px',}
            }, "用户信息"));
          }
          if(data.deviceCameraCode){
            messageList.push(h('button',{
              on:{click:()=>{this.viewCamera(data.sn,data.deviceCameraCode);}},
              style:{'margin-right':'5px',}
            }, "查看监控"));
            // messageList.push(h('button',{
            //   on:{click:()=>{this.viewCameraPlus(data.sn,data.deviceCameraCode,data.yzm,data.tdh);}},
            //   style:{'margin-right':'5px',}
            // }, "视频对讲"));
          }

        }


        let userPhone = data.user.phone;
        if(that.alarmPhoneHad(userPhone)){
          return;
        }
        that.alarmPhone.push(userPhone);


        this.$notify({
          title: title,
          message:  h('p', {
            style:{
              'padding':'10px 0',
              width:'100%'
            },
          }, messageList),
          type: 'warning',
          duration:0,
          customClass:'baojing',
          offset:300,
          onClose:function(){
            that.playAudio(2);
            clearTimeout(that.setTimeoutPaused);
            that.removeAlarmPhone(userPhone);
          }
        });


        // this.$notify({
        //   title: '',
        //   dangerouslyUseHTMLString: true,
        //   duration: 0,
        //   type: 'warning',
        //   customClass: 'notify-warning',
        //   message: '<div class="alertTile"></div>'
        // });




      }

      this.reset();
    },
    close: function () {
      console.log("socket已经关闭")
      //重连
      this.reconnect();
    },

    //关闭报警声音
    clickBtn(){
      this.playAudio(2);
      clearTimeout(this.setTimeoutPaused);
    },
    playAudio(type){
      switch (type) {
        case 1://播放音频
          if(this.showBell){
            this.$refs.audio.load()
            this.$refs.audio.play()
          }
          break
        case 2://暂停音频
          this.$refs.audio.pause();
          this.$notify.close()
          break
      }
    },


    reconnect() {//重新连接
      var that = this;
      if(that.lockReconnect) {
        return;
      }
      that.lockReconnect = true;

      //没连接上会一直重连，设置延迟避免请求过多
      that.timeoutnum && clearTimeout(that.timeoutnum);
      that.timeoutnum = setTimeout(function () {
        //新连接
        that.websocketInit();
        that.lockReconnect = false;
      },5000);

    },
    reset(){//重置心跳
      var that = this;
      //清除时间
      clearTimeout(that.timeoutObj);
      clearTimeout(that.serverTimeoutObj);
      //重启心跳
      that.start();
    },
    start(){
      //开启心跳
      var self = this;
      self.timeoutObj && clearTimeout(self.timeoutObj);
      self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);

      self.timeoutObj = setTimeout(function(){

        //这里发送一个心跳，后端收到后，返回一个心跳消息，
        if (self.socket.readyState == 1) {//如果连接正常
          let jsonObj = {userName:self.staffCode,msg:"heartCheck"};
          self.socket.send(JSON.stringify(jsonObj));
        }
        else{//否则重连
          self.reconnect();
        }

        self.serverTimeoutObj = setTimeout(function() {
          //超时关闭
          self.socket.close();
        }, self.timeout);

      }, self.timeout)

    },
    destroyed () {
      // 销毁监听
      this.socket.close()
    },



    removeAlarmPhone(phone){
      //console.log(phone);
      for(let i=0;i<this.alarmPhone.length;i++){
        if(this.alarmPhone[i] == phone){
          this.alarmPhone.splice(i,1);
        }
      }
      //console.log(this.alarmPhone);
    },
    alarmPhoneHad(phone){
      for(let i=0;i<this.alarmPhone.length;i++){
        if(this.alarmPhone[i] == phone){
          return true;
        }
      }
      return false;
    },




    viewCamera(sn,deviceCameraCode){
      this.$refs.myViewCamera.init(sn,deviceCameraCode);
      this.showCamera =!this.showCamera;
      this.$refs.audio.pause();
    },
    viewCameraPlus(sn,deviceCameraCode,yzm,tdh){
      this.$refs.myViewCameraPlus.init3(sn,deviceCameraCode,yzm,tdh);
      this.showCameraPlus =!this.showCameraPlus;
      this.$refs.audio.pause();
    },
    handleElderlyInfo(row){
      this.showModalInfo = !this.showModalInfo;
      this.$nextTick(()=>{
        this.$refs.myInfoMain.init(row);
      });

    },



    menuTag(){
      if(!this.isCollapse){
        this.isCollapse = true;
        this.contentStyleObj.flexBasis = 64 + 'px'
        this.menuTagImg = menuTagImgToRight;

        window.localStorage.setItem("isCollapse",'true');

      }else{
        this.isCollapse = false;
        this.contentStyleObj.flexBasis = 200 + 'px'
        this.menuTagImg = menuTagImgToLeft;

        window.localStorage.setItem("isCollapse",'false');

      }
    },

    getListMenu(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'Staff/StaffMenu',
        data: {
          timeStr:timeStr,
          sign:hex_md5( "timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then( (response)=> {
        if(response.data.error == 0){
          let listMenuDTO = [];
          listMenuDTO = response.data.data;


          //set listMenuDTO
          this.$store.commit('update', ['listMenuDTO',listMenuDTO]);
          window.localStorage.setItem('listMenuDTO', JSON.stringify(listMenuDTO));





          //set listMenuTop
          let listMenuDTO2 = [];
          for(var i=0;i<listMenuDTO.length;i++){
            var obj = {"name":listMenuDTO[i].name,"menuCode":listMenuDTO[i].menuCode,"url":listMenuDTO[i].url};
            listMenuDTO2.push(obj);
          }
          this.$store.commit('update', ['listMenuTop',listMenuDTO2]);
          window.localStorage.setItem('listMenuTop', JSON.stringify(listMenuDTO2));


          if(listMenuDTO.length>0){

            //set activeMenuTop
            this.$store.commit('update', ['activeMenuTop','/indexTop']);
            window.localStorage.setItem('activeMenuTop','/indexTop');

            let listMenuLeft = listMenuDTO[0].listMenuDTO;
            this.$store.commit('update', ['activeMenuTop',listMenuDTO[0].url]);
            window.localStorage.setItem('activeMenuTop',listMenuDTO[0].url);
            if(listMenuLeft[0].listMenuDTO.length==0){
              this.$router.push(listMenuLeft[0].url)
            }else{
              this.$router.push(listMenuLeft[0].listMenuDTO[0].url)
            }
            this.leftMenusShow=true

            //set listMenuLeft
            this.$store.commit('update', ['listMenuLeft',listMenuLeft]);
            window.localStorage.setItem('listMenuLeft', JSON.stringify(listMenuLeft));
          }



        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }


      }).catch(function (error) {
        console.log(error);
      });
    },

    TopMenuGo(url,menuCode){
      console.log(menuCode)
      //update activeMenuTop
      this.$store.commit('update', ['activeMenuTop',url]);
      window.localStorage.setItem('activeMenuTop', url);
      //update listMenuLeft
      let listMenuDTO = JSON.parse(window.localStorage.getItem('listMenuDTO'));
      for(var i=0;i<listMenuDTO.length;i++){
        if(listMenuDTO[i].url == url){
          let listMenuLeft = listMenuDTO[i].listMenuDTO;
          this.$store.commit('update', ['listMenuLeft',listMenuLeft]);
          window.localStorage.setItem('listMenuLeft', JSON.stringify(listMenuLeft));
          this.leftMenusShow=true
          if(listMenuLeft[0].listMenuDTO.length==0){
            this.$router.push(listMenuLeft[0].url)
          }else{
            this.$router.push(listMenuLeft[0].listMenuDTO[0].url)
          }
          return;
        }
      }

    },
    TopMenuGoIndex(){
      // if(!this.isks){
      //   this.leftMenusShow=false;
      //   this.$router.push('/home/index');
      //   this.$store.commit('update', ['activeMenuTop','/indexTop']);
      //   window.localStorage.setItem('activeMenuTop', '/indexTop');
      // }
      this.$router.push('/home/index');
    },
    getHight(){
      this.contentStyleObj.height = window.innerHeight - 50 + 'px'

      let mainHeight = window.innerHeight-220;
      if(mainHeight<200){
        mainHeight = 200;
      }
      this.$store.commit('update', ['tableHeight',mainHeight]);

      let mainWidth = window.innerWidth;
      if(mainWidth<200){
        mainWidth = 200;
      }
      this.$store.commit('update', ['tableWidth',mainWidth]);


      this.contentStyleObj2.top = (window.innerHeight - 50) / 2 - 22 +'px';

    },

    loginOut(){
      this.$confirm('是否退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        document.getElementById("tk").innerText = '';

        removeToken();
        window.localStorage.setItem('activeInstitutionCode', null);
        window.localStorage.setItem('activeStaffCode', null);
        window.localStorage.setItem('activeMenuTop', null);
        window.localStorage.setItem('listMenuDTO', null);
        window.localStorage.setItem('listMenuTop', null);
        window.localStorage.setItem('listMenuLeft', null);
        window.localStorage.setItem('isHome', null);
        this.$store.commit('update', ['loginToken',null]);
        if(this.staffDTO.roleName=="政府管理员"){
          console.log(this.socket)
          if(this.socket){
            this.destroyed()
            clearTimeout(this.timeoutObj);
            clearTimeout(this.serverTimeoutObj);
            clearTimeout(this.timeAxiosWS);
            this.lockReconnect = true;
          }
        }
        this.$router.push({ path: '/login' })

      }).catch(e=>e)
    },

    editPasswordSure(){
      this.$confirm('确定修改密码?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.updatePassword()
      }).catch(e=>e)
    },
    updatePassword(){
      if(this.newPassword.length<6){
        this.$message('新密码至少为六位')
        return;
      }
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'Staff/EditMyPassword',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          oldPassword:this.oldPassword,
          newPassword:this.newPassword
        }
      }).then( (response)=> {
        console.log(response);
        if(response.data.error == 0){
          this.$message('修改成功');
          this.batchDialog=false;

          document.getElementById("tk").innerText = '';

          removeToken();
          window.localStorage.setItem('activeInstitutionCode', null);
          window.localStorage.setItem('activeStaffCode', null);
          window.localStorage.setItem('activeMenuTop', null);
          window.localStorage.setItem('listMenuDTO', null);
          window.localStorage.setItem('listMenuTop', null);
          window.localStorage.setItem('listMenuLeft', null);
          this.$router.push({ path: '/login' })


        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    getAxios(url){
      return new Promise((resolve, reject) => {
        this.$axios({
          method: 'post',
          url: this.$shopUrl+url,
          data: {
            timeStr:timeStr,
            sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
            staffCode: getStaffCode(),
          }
        }).then((response)=> {
          if(response.data.error == 0){
            resolve(response.data.data);
          }else if(response.data.error == 1){
            this.$message.error(response.data.message)
          }
        }).catch(function (error) {
          reject(error.data)
        });
      });
    },


  },

}

</script>


<style>
.el-notification.baojing.right {
  z-index:35 !important;
}
</style>

<style lang="scss" scoped>
@import "../../src/css/main.css";
@import  '../../src/css/boots.css';
</style>

<style>
body {
  background-color: #141e30;
}
#login-form, #device-form {
  width: 500px;
  margin: 20px auto 20px;
}
.usr-info {
  text-align: center;
}
.usr-pho {
  margin-top: 35px;
  width: 120px;
  height: 120px;
}
.usr-name {
  margin-top: 10px;
  font-weight: 500;
  font-size: 30px;
  line-height: 42px;
  color: #1A1A1A;
}
.incoming-call-tip {
  font-size: 16px;
  line-height: 22px;
  color: #666666;
}
.op-btns {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.op-btns img {
  width: 80px;
  height: 80px;
  margin: 16px 40px;
  cursor: pointer;
}
.op-txt {
  line-height: 20px;
  text-align: center;
}
#outing-call-view, #call-view {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 10052;
  background: #3c3667;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
#outing-call-view .op-btns {
  margin-top: 50px;
}
.peer-pho {
  width: 104px;
  height: 104px;
  margin-top: 50px;
}
.peer-name {
  font-size: 60px;
  line-height: 86px;
}
.outing-call-tip {
  font-size: 42px;
  line-height: 60px;
  color: rgba(225, 225, 225, .5);
}
#call-view .op-btns {
  position: absolute;
  bottom: 50px;
}
.main-view {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  background-image: url('https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661773897681/audioBg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #fff;
  text-align: center;
}
.main-view video {
  width: 100%;
  object-fit: fill;
}
.main-view .audio-name {
  margin-top: 100px;
  font-size: 62px;
  line-height: 87px;
}
.main-view .audio-call {
  font-size: 36px;
  line-height: 50px;
  color: rgba(225, 225, 225, .5);
  margin-top: 17px;
}
.main-view .audio-tip-wrap {
  position: absolute;
  top: 0;
}
.sub-view {
  width: 320px;
  height: 192px;
  position: absolute;
  left: 48px;
  top: 48px;
  background-image: url('https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661773897681/audioBg.png');
  background-repeat: no-repeat;
  background-size: 100%;
  color: #fff;
  z-index: 1;
}
.sub-view video {
  width: 320px;
  height: 192px;
  object-fit: fill;
}
.sub-view .audio-tip-wrap {
  position: absolute;
  bottom: 10px;
  right: 10px;
}
.sub-view .audio-name {
  font-size: 48px;
  line-height: 67px;
  max-width: 300px;
}
.sub-view .audio-call {
  font-size: 24px;
  line-height: 34px;
  text-align: right;
}
#message-alert {
  position: fixed;
  z-index: 1053;
  width: 300px;
  right: 0;
  top: 10px;
  display: none;
}
.desc-title {
  text-align: center;
  margin-bottom: 20px;
}
</style>
